import OurSolutionsCard from './OurSolutionsCard';

export default OurSolutionsCard;
